/**
 * Evidence bullets from a weed scan render as short chips, not prose. The
 * model occasionally overruns its token budget and stores an item cut off
 * mid-word: one live row ends "...including a clo" at 220 characters.
 * Measured over the stored corpus: 139 items, mean length 59, three above 120.
 *
 * A truncated run-on is worse than no bullet, so anything past chip length is
 * dropped rather than shown. Both the owner result and the read-only share
 * surface filter through here so the two cannot drift.
 */
export const MAX_EVIDENCE_LINE_LENGTH = 120

export function evidenceLines(value: unknown, limit = 5): string[] {
  if (!Array.isArray(value)) return []
  return value
    .filter((item): item is string => typeof item === 'string')
    .map((item) => item.replace(/\s+/g, ' ').trim())
    .filter((item) => item.length > 0 && item.length <= MAX_EVIDENCE_LINE_LENGTH)
    .slice(0, limit)
}
